import React, { Suspense } from 'react';
import { ValueType } from '@atlaskit/select/types';
import { OptionType, FilterComponentProps } from '../filter-show-more';

function isOptionType<T>(o: ValueType<OptionType<T>>): o is OptionType<T> {
  return (o as OptionType<T>).value !== undefined;
}

const AsyncSelect = React.lazy(() =>
  import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "@atlaskit-internal_@atlassian/search-dialog/show-more/select" */ '@atlaskit/select/AsyncSelect'
  ).then((module) => {
    return {
      default: module.default,
    };
  }),
);

export class AsyncSelectFilterComponent<T = 'string'> extends React.Component<
  FilterComponentProps<T>
> {
  onChange = (
    value: unknown, // Async load types don't accept generics hence this breaks.
    { action }: { action: string },
  ) => {
    if (
      isOptionType(value as ValueType<OptionType<T>>) &&
      (action === 'select-option' || action === 'create-option')
    ) {
      this.props.onConfirm(value as OptionType<T>);
    }
  };
  render() {
    return (
      <Suspense fallback={() => <></>}>
        <AsyncSelect
          defaultOptions={this.props.defaultOptions}
          loadOptions={this.props.loadOptions}
          autoFocus
          openMenuOnFocus
          placeholder={this.props.placeholderText}
          onChange={this.onChange}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              this.props.onMenuClosed();
              e.stopPropagation();
              this.props.refocusEditLink();
            }
          }}
          onBlur={() => {
            this.props.refocusEditLink();
          }}
          menuPosition="fixed"
          captureMenuScroll
          onMenuClose={() => this.props.onMenuClosed()}
        />
      </Suspense>
    );
  }
}

export default AsyncSelectFilterComponent;
